import { Box, Link } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import useStyles from './styles';

const AuctionDetails = ({ auction, trackAuctionLocation }) => {
    const classes = useStyles();

    return (
        <div>
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Company</span>
                <span className={`${classes.alignRight}`}>{auction.auctioneer?.company}</span>
            </Box>
            <hr />
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Type</span>
                <span>{auction.type}</span>
            </Box>
            <hr />
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Online Bidding</span>
                <span>{auction.online}</span>
            </Box>
            <hr />
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Location</span>
                <span>{auction.location}</span>
            </Box>
            <hr />
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Address</span>
                <Link
                    href={`https://maps.google.com/?q=${auction.address}`}
                    rel='noreferrer'
                    target='_blank'
                    onClick={trackAuctionLocation}
                    className={classes.address}
                >
                    {auction.address}
                </Link>
            </Box>
            <hr />
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Date</span>
                <span>{DateTime.fromMillis(Number(auction.date)).toFormat('EEE. MMM dd, yyyy')}</span>
            </Box>
            <hr />
            <Box justifyContent='space-between' display='flex' className={classes.detailRow}>
                <span className={classes.semiBold}>Time</span>
                <span>{DateTime.fromMillis(Number(auction.date)).toFormat('h:mm ZZZZ')}</span>
            </Box>
        </div>
    );
};

export default AuctionDetails;
